import { autoinject, transient } from 'aurelia-dependency-injection';
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { WorkflowAssignmentsUrls } from '../../constants/workflow/workflow-assignments.constants';
import { WorkflowTakeOwnershipResponse, WorkflowStateUpdatedResponse, GetWorkflowStateResponse } from '../../models/workflow/workflow.models';

@autoinject()
@transient()
export class WorkflowAssignmentsService {

    constructor(private requestClient: RequestClientService) {
    }

    getWorkflowState(entityId: number, entityTypeId: number, workflowStateId: number = null): Promise<GetWorkflowStateResponse> {
        return this.requestClient.post(WorkflowAssignmentsUrls.GetWorkflowState, {}, { entityId, entityTypeId, workflowStateId });
    }

    reassign(assignmentId: number, userId: number, departmentId: number, remarks: string): Promise<WorkflowTakeOwnershipResponse> {
        return this.requestClient.post(WorkflowAssignmentsUrls.Reassign, {}, { assignmentId, userId, departmentId, remarks });
    }

    takeOwnership(assignmentId: number): Promise<WorkflowTakeOwnershipResponse> {
        return this.requestClient.post(WorkflowAssignmentsUrls.TakeOwnership, {}, { assignmentId: assignmentId });
    }

    executeAction(workflowStateId: number, activityName: string, action: string, assignmentId: number, reasonId: number, remarks: string, meta: string, files: File[] = null): Promise<WorkflowStateUpdatedResponse> {
        return this.requestClient.postFormData(WorkflowAssignmentsUrls.ExecuteAction, { workflowStateId, activityName, action, assignmentId, reasonId, remarks, meta, files });
    }

    cancelWorkflow(workflowStateId: number, cancellationReasonId: number, cancellationNotes: string): Promise<GetWorkflowStateResponse> {
        return this.requestClient.post(WorkflowAssignmentsUrls.CancelWorkflow, {}, { workflowStateId, cancellationReasonId, cancellationNotes });
    }
}
